export const CLINIC_CARE_MANAGERS_TABLE_ITEMS_PER_PAGE = 10;
